import { render } from "./SalePricesForm.vue?vue&type=template&id=65c21880&scoped=true&ts=true"
import script from "./SalePricesForm.vue?vue&type=script&lang=ts"
export * from "./SalePricesForm.vue?vue&type=script&lang=ts"

import "./SalePricesForm.vue?vue&type=style&index=0&id=65c21880&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c21880"]])

export default __exports__